import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import { Button } from '@openx/components-core/lib/Button/Button';
import { DialogTitle } from '@openx/components-core/lib/Dialog/DialogTitle/DialogTitle';
import { useTranslation } from 'react-i18next';

export type ExcludesMarketConflictModalProps = {
  isOpen: boolean;
  onRemoveExcludes: () => void;
  onClearConflictingRegion?: () => void;
  isClearRegionActionAvailable?: boolean;
};

export const ExcludesMarketConflictModal = ({
  isOpen,
  onRemoveExcludes,
  onClearConflictingRegion,
  isClearRegionActionAvailable = false,
}: ExcludesMarketConflictModalProps) => {
  const { t } = useTranslation();

  const handleClose = (_event: React.SyntheticEvent, reason: 'backdropClick' | 'escapeKeyDown') => {
    if (reason === 'escapeKeyDown') {
      return;
    }
  };

  return (
    <Dialog open={isOpen} onClose={handleClose}>
      <DialogTitle>{t('Exclusions not available for this setup')}</DialogTitle>

      <DialogContent dividers>
        <Box>
          <Typography data-test="excludes-market-conflict-modal-body">
            {t(
              'Your include groups use cross-region targeting or sellable multipartner (Data Marketplace) segments on non-US markets between multiple groups. Exclusions cannot be combined with that configuration. Remove all exclusions, or adjust include groups if you need exclusions.'
            )}
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions>
        {isClearRegionActionAvailable && onClearConflictingRegion != null && (
          <Button
            data-test="excludes-market-conflict-clear-region"
            onClick={onClearConflictingRegion}
            color="primary"
            variant="outlined"
          >
            {t('Clear conflicting region')}
          </Button>
        )}
        <Button
          data-test="excludes-market-conflict-remove-excludes"
          onClick={onRemoveExcludes}
          color="error"
          variant="contained"
        >
          {t('Remove excludes section')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
